import React from 'react';
import {
  classNames,
  headingClassNames,
  HeadingClassNameProps,
  layoutClassNames,
  LayoutClassNameProps,
  textClassNames,
  TextClassNameProps,
} from './classNames';

export type HeadingElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    HeadingClassNameProps,
    LayoutClassNameProps,
    TextClassNameProps {
  as?: HeadingElement;
}

const Heading: React.FC<HeadingProps> = ({
  as: Component = 'h2',
  className,
  children,
  displaySize,
  fontSize,
  fontWeight,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  visualLevel,
  textColor,
  textDecoration,
  textReset,
  ...props
}) => (
  <Component
    className={classNames(
      headingClassNames({
        displaySize,
        visualLevel,
      }),
      textClassNames({
        fontSize,
        fontWeight,
        textColor,
        textDecoration,
        textReset,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </Component>
);

export default Heading;
